import React, { useState } from 'react';
import { Breadcrumb, Button, ConfigProvider, Form, Input, Space } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import { createFertilizersParametersRequest } from '../requests/fertilizersRequests';
import 'moment-timezone';

const FertilizersParametersAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createFertilizersParametersRequest(values).then(() => {
      form.resetFields();
      toggleButtonLoading(false);
    });
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Nawozy</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilizers-parameters">Nawozy skład</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilizers-parameters/add">+</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
          >
            <Form.Item
              name="name"
              label="Nazwa"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="azot_CAL" label="Azot N całkowity">
              <Input />
            </Form.Item>
            <Form.Item name="azot_AZO" label="Azot N azotanowy">
              <Input />
            </Form.Item>
            <Form.Item name="azot_AMO" label="Azot N amonowy">
              <Input />
            </Form.Item>
            <Form.Item name="azot_AMI" label="Azot N amidowy">
              <Input />
            </Form.Item>
            <Form.Item
              name="fosfor_CAL"
              label="Pięciotlenek fosforu P₂O₅ całkowity"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="fosfor_WOD"
              label="Pięciotlenek fosforu P₂O₅ rozpuszczalny w wodzie"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="fosfor_AMO"
              label="Pięciotlenek fosforu P₂O₅ rozpuszczalny w obojętnym roztworze cytrynianu amonu"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="fosfor_MRO"
              label="Pięciotlenek fosforu P₂O₅ rozpuszczalny w kwasie mrówkowym"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="potas_WOD"
              label="Tlenek potasu K₂O rozpuszczalny w wodzie"
            >
              <Input />
            </Form.Item>
            <Form.Item name="wapn_CAL" label="Tlenek wapnia CaO całkowity">
              <Input />
            </Form.Item>
            <Form.Item
              name="wapn_WOD"
              label="Tlenek wapnia CaO rozpuszczalny w wodzie"
            >
              <Input />
            </Form.Item>
            <Form.Item name="magnez_CAL" label="Tlenek magnezu MgO całkowity">
              <Input />
            </Form.Item>
            <Form.Item
              name="magnez_WOD"
              label="Tlenek magnezu MgO rozpuszczalny w wodzie"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="siarka_CAL"
              label="Trójtlenek siarki SO₃ całkowity"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="siarka_WOD"
              label="Trójtlenek siarki SO₃ rozpuszczalny w wodzie"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="mikro_SKL"
              label="Mikroskładniki i składniki korzystne"
            >
              <Input />
            </Form.Item>
            <Form.Item name="inhibitor" label="Inhibitor">
              <Input />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default FertilizersParametersAdd;
